export const COMPANIES_LIST = "COMPANIES_LIST";
